import React from "react";
import { useTranslation } from "react-i18next";
import { useMoney } from "../context/MoneyContext";
import Hint from "./Hint";

// Shared tax-profile inputs (personal marginal rate, church tax, filing status) used
// wherever a German tax estimate is shown — Holdings' Tax Impact panel and the
// Insurance Policies page. Backed by MoneyContext so editing it in either place
// keeps both in sync.
export default function TaxSettings({ testid }) {
  const { t } = useTranslation();
  const { marginalTaxRate, setMarginalTaxRate, churchTaxPct, setChurchTaxPct, married, setMarried } = useMoney();

  return (
    <div data-testid={testid} className="flex flex-wrap items-end gap-x-6 gap-y-3 p-4 rounded-xl bg-slate-50 border border-slate-100">
      <div>
        <Hint term="Marginal Tax Rate"><span className="label">{t("tax.marginalRate")}</span></Hint>
        <div className="flex items-center gap-1.5 mt-1.5">
          <input data-testid="tax-marginal-rate" type="number" min="0" max="100" step="1"
            value={marginalTaxRate}
            onChange={(e) => setMarginalTaxRate(Number(e.target.value))}
            className="input w-20 py-1.5 text-sm tabular" />
          <span className="text-sm text-slate-400">%</span>
        </div>
      </div>
      <div>
        <Hint term="Church Tax"><span className="label">{t("tax.churchTax")}</span></Hint>
        <select data-testid="tax-church-select" value={churchTaxPct}
          onChange={(e) => setChurchTaxPct(Number(e.target.value))}
          className="input w-auto py-1.5 mt-1.5 text-sm font-medium">
          <option value={0}>{t("tax.churchNone")}</option>
          <option value={8}>8% ({t("tax.churchBavariaBw")})</option>
          <option value={9}>9%</option>
        </select>
        {/* Church tax reveals religious affiliation (DSGVO Art. 9), so the basis is
            explicit consent, and the field says so where the choice is made. */}
        <p className="text-[11px] text-slate-400 mt-1.5 max-w-xs leading-snug" data-testid="tax-church-consent">
          {t("tax.churchConsent")}
        </p>
      </div>
      <label className="flex items-center gap-2 pb-2 cursor-pointer">
        <input data-testid="tax-married-checkbox" type="checkbox" checked={married}
          onChange={(e) => setMarried(e.target.checked)} className="w-4 h-4 rounded accent-brand-500" />
        <span className="text-sm text-slate-600">{t("tax.married")}</span>
      </label>
    </div>
  );
}
